module.exports = __webpack_public_path__ + "static/media/Angel.a1cf2156.svg";